var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import TicketInstructions from "@irati-web/perks/src/components/Tickets/TicketInstructions";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
// @todo move TicketInstructions to ui folder and refactor to typescript
import Expand from "@irati/ui/src/Expander";
import { Label1 } from "@irati/ui/src/Labels";
import { InstructionHeader, HeaderWrapper, RewardAvatar, Title, SubTitle, Message, StyledInstructions } from "./styled";
var PopUpHeader = /** @class */ (function (_super) {
    __extends(PopUpHeader, _super);
    function PopUpHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopUpHeader.prototype.render = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, thumbnailImage = _a.thumbnailImage, instructions = _a.instructions, termsAndConditions = _a.termsAndConditions, message = _a.message, formatMessage = _a.formatMessage;
        return (React.createElement(HeaderWrapper, null,
            React.createElement(RewardAvatar, { src: thumbnailImage, alt: title, marginTop: -2, large: true, withShadow: true }),
            React.createElement(Title, null, title),
            subtitle && React.createElement(SubTitle, null, subtitle),
            message && React.createElement(Message, null, message),
            instructions && (React.createElement(React.Fragment, null,
                React.createElement(InstructionHeader, null,
                    React.createElement(FormattedMessage, { id: "recognition.account.rewards.instructionHeader" })),
                React.createElement("div", null,
                    React.createElement(Expand, { hideText: formatMessage({ id: "recognition.account.rewards.hideInstructions" }), showText: formatMessage({ id: "recognition.account.rewards.viewInstructions" }), HeaderLabel: Label1 },
                        React.createElement(StyledInstructions, null,
                            React.createElement(TicketInstructions, { instructions: instructions })))))),
            termsAndConditions && (React.createElement("div", null,
                React.createElement(Expand, { hideText: formatMessage({ id: "recognition.account.rewards.hideTerms" }), showText: formatMessage({ id: "recognition.account.rewards.viewTerms" }), HeaderLabel: Label1 },
                    React.createElement(StyledInstructions, null,
                        React.createElement(TicketInstructions, { instructions: termsAndConditions })))))));
    };
    PopUpHeader.defaultProps = {
        subtitle: null,
        instructions: null,
        termsAndConditions: null
    };
    return PopUpHeader;
}(Component));
export default injectIntl(PopUpHeader);
